// extracted by mini-css-extract-plugin
export var noSpinners = "_s5-6";
export var percentageInput = "_s5-7";
export var variantColor1 = "_s5-0";
export var variantColor2 = "_s5-1";
export var variantColor3 = "_s5-2";
export var variantColor4 = "_s5-3";
export var variantColor5 = "_s5-4";
export var variantColor6 = "_s5-5";